import React, { useState } from 'react';
import { Col, Empty, Row, Spin } from 'antd';

import CardSub from '@/components/Subscription/Card';

import './index.scss';
import { PackageService } from '@/services';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { uniqueId } from 'lodash';

function SubscriptionsList() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState();
  const fetchData = async () => {
    const res = await PackageService.getCurrentSubscription();
    if (res.success && res.data?.id) {
      setCurrentData(res.data);
    }
    const { success, data: dataRes } = await PackageService.list();
    if (success) {
      const { results } = dataRes;
      setData(results);
    }
    setLoading(false);
  };

  useBeforeRender(() => fetchData(), []);

  const renderListData = () => {
    if (data?.length === 0) {
      return <Empty />;
    }
    return data.map((v) => (
      <Col
        xxl={{ span: 6 }}
        xl={{ span: 8 }}
        md={{ span: 12 }}
        span={24}
        key={uniqueId()}
      >
        <CardSub data={v} currentID={currentData?.package?.id} />
      </Col>
    ));
  };

  return (
    <div className="subscriptions-list">
      <Spin spinning={loading}>
        <Row gutter={[16, 24]}>{data?.length > 0 && renderListData()}</Row>
      </Spin>
    </div>
  );
}

export default SubscriptionsList;
